import { render, staticRenderFns } from "./LayoutCrud.vue?vue&type=template&id=26fe70ca&scoped=true"
import script from "./LayoutCrud.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutCrud.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LayoutCrud.vue?vue&type=style&index=0&id=26fe70ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fe70ca",
  null
  
)

export default component.exports